// src/Redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import tokenReducer from "./Auth/TokenSlice";
import menuReducer from "./Menu/MenuSlice";
import userReducer from "./User/UserSlice"; // Import UserSlice (already present)

const getTokenFromSessionStorage = () => {
  const token = sessionStorage.getItem("jwt_token");
  return token ? token : null;
};

const preloadedState = {
  token: {
    value: getTokenFromSessionStorage(),
  },
  user: { // Optional: Initialize user state for consistency
    notificationCount: 0,
  },
};

const store = configureStore({
  reducer: {
    token: tokenReducer,
    menu: menuReducer,
    user: userReducer, // Include userReducer in the reducer configuration (already present)
  },
  preloadedState,
});

store.subscribe(() => {
  const { token } = store.getState();
  if (token.value !== sessionStorage.getItem("jwt_token")) {
    sessionStorage.setItem("jwt_token", token.value);
  }
});

export default store;